import { colors } from "../../Styles";

export function Info({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M141.73,9.29C68.71,9.29 9.29,68.71 9.29,141.73C9.29,214.75 68.7,274.17 141.73,274.17C214.76,274.17 274.17,214.76 274.17,141.73C274.17,68.7 214.76,9.29 141.73,9.29ZM141.73,248.18C83.03,248.18 35.28,200.43 35.28,141.73C35.28,83.03 83.03,35.28 141.73,35.28C200.43,35.28 248.18,83.03 248.18,141.73C248.18,200.43 200.43,248.18 141.73,248.18Z"/>
      <g transform="matrix(0.854479,0,0,0.733212,42.9966,122.192)">
          <path d="M99.306,-39.869L99.306,-76.432L131.79,-76.432L131.79,-39.869L99.306,-39.869ZM99.306,129.725L99.306,-19.619L131.79,-19.619L131.79,129.725L99.306,129.725Z"/>
      </g>
    </svg>
  );
}